import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import type { ValidationMode } from 'react-hook-form'
import { ApiKeyModel } from '../../../models/api-key-model'

export const MSG_REQUIRED_FIELD = 'O campo é obrigatório.'

export const apiKeyDefaultValues: ApiKeyModel = {
  id: '',
  name: '',
  keyHash: '',
  createdAt: '',
  expiresAt: null,
  createdBy: '',
  companyId: ''
}

const mode: keyof ValidationMode = 'all'

export const apiKeySchemaValidation = yup.object({
  id: yup.string(),
  name: yup.string().required('required'),
})

export const apiKeyUseFormArgs = {
  mode,
  defaultValues: apiKeyDefaultValues,
  resolver: yupResolver(apiKeySchemaValidation),
}

export interface ApiKeyTypes
  extends yup.InferType<typeof apiKeySchemaValidation> { }
